// Generated from https://ripped.topps.com/uk/complete-2025-26-topps-premier-league-checklist/
window.CHECKLIST = {
  "teamBadges": [
    {
      "player": "Aston Villa",
      "team": "Arsenal",
      "note": "AFC Bournemouth"
    },
    {
      "player": "Brighton & Hove Albion",
      "team": "Brentford",
      "note": "Chelsea"
    },
    {
      "player": "Everton",
      "team": "Crystal Palace",
      "note": "Fulham"
    },
    {
      "player": "Manchester United",
      "team": "Manchester City",
      "note": "Newcastle United"
    },
    {
      "player": "Tottenham Hotspur",
      "team": "Nottingham Forest",
      "note": "West Ham United"
    },
    {
      "player": "Burnley FC",
      "team": "Wolverhampton Wanderers",
      "note": "Leeds United"
    },
    {
      "player": "Team Badge",
      "team": "Arsenal",
      "note": ""
    },
    {
      "player": "Team Badge",
      "team": "Aston Villa",
      "note": ""
    },
    {
      "player": "Team Badge",
      "team": "AFC Bournemouth",
      "note": ""
    },
    {
      "player": "Team Badge",
      "team": "Brentford",
      "note": ""
    },
    {
      "player": "Team Badge",
      "team": "Brighton & Hove Albion",
      "note": ""
    },
    {
      "player": "Team Badge",
      "team": "Chelsea",
      "note": ""
    },
    {
      "player": "Team Badge",
      "team": "Crystal Palace",
      "note": ""
    },
    {
      "player": "Team Badge",
      "team": "Everton",
      "note": ""
    },
    {
      "player": "Team Badge",
      "team": "Fulham",
      "note": ""
    },
    {
      "player": "Team Badge",
      "team": "Manchester City",
      "note": ""
    },
    {
      "player": "Team Badge",
      "team": "Manchester United",
      "note": ""
    },
    {
      "player": "Team Badge",
      "team": "Newcastle United",
      "note": ""
    },
    {
      "player": "Team Badge",
      "team": "Nottingham Forest",
      "note": ""
    },
    {
      "player": "Team Badge",
      "team": "Tottenham Hotspur",
      "note": ""
    },
    {
      "player": "Team Badge",
      "team": "West Ham United",
      "note": ""
    },
    {
      "player": "Team Badge",
      "team": "Wolverhampton Wanderers",
      "note": ""
    },
    {
      "player": "Team Badge",
      "team": "Burnley FC",
      "note": ""
    },
    {
      "player": "Team Badge",
      "team": "Leeds United",
      "note": ""
    },
    {
      "player": "Team Badge",
      "team": "Sunderland",
      "note": ""
    }
  ],
  "teamBadgePLChampions": [],
  "base": [
    {
      "player": "David Raya",
      "team": "Arsenal",
      "note": ""
    },
    {
      "player": "William Saliba",
      "team": "Arsenal",
      "note": ""
    },
    {
      "player": "Gabriel Magalhães",
      "team": "Arsenal",
      "note": ""
    },
    {
      "player": "Jurriën Timber",
      "team": "Arsenal",
      "note": ""
    },
    {
      "player": "Mikel Merino",
      "team": "Arsenal",
      "note": ""
    },
    {
      "player": "Thomas Partey",
      "team": "Arsenal",
      "note": ""
    },
    {
      "player": "Declan Rice",
      "team": "Arsenal",
      "note": ""
    },
    {
      "player": "Myles Lewis-Skelly",
      "team": "Arsenal",
      "note": ""
    },
    {
      "player": "Martin Ødegaard",
      "team": "Arsenal",
      "note": ""
    },
    {
      "player": "Ethan Nwaneri",
      "team": "Arsenal",
      "note": ""
    },
    {
      "player": "Bukayo Saka",
      "team": "Arsenal",
      "note": ""
    },
    {
      "player": "Gabriel Martinelli",
      "team": "Arsenal",
      "note": ""
    },
    {
      "player": "Leandro Trossard",
      "team": "Arsenal",
      "note": ""
    },
    {
      "player": "Kai Havertz",
      "team": "Arsenal",
      "note": ""
    },
    {
      "player": "Emiliano Martínez",
      "team": "Aston Villa",
      "note": ""
    },
    {
      "player": "Pau Torres",
      "team": "Aston Villa",
      "note": ""
    },
    {
      "player": "Ezri Konsa",
      "team": "Aston Villa",
      "note": ""
    },
    {
      "player": "Matty Cash",
      "team": "Aston Villa",
      "note": ""
    },
    {
      "player": "Lucas Digne",
      "team": "Aston Villa",
      "note": ""
    },
    {
      "player": "Boubacar Kamara",
      "team": "Aston Villa",
      "note": ""
    },
    {
      "player": "Amadou Onana",
      "team": "Aston Villa",
      "note": ""
    },
    {
      "player": "John McGinn",
      "team": "Aston Villa",
      "note": ""
    },
    {
      "player": "Youri Tielemans",
      "team": "Aston Villa",
      "note": ""
    },
    {
      "player": "Jacob Ramsey",
      "team": "Aston Villa",
      "note": ""
    },
    {
      "player": "Morgan Rogers",
      "team": "Aston Villa",
      "note": ""
    },
    {
      "player": "Louie Barry",
      "team": "Aston Villa",
      "note": "Rookie"
    },
    {
      "player": "Donyell Malen",
      "team": "Aston Villa",
      "note": ""
    },
    {
      "player": "Ollie Watkins",
      "team": "Aston Villa",
      "note": ""
    },
    {
      "player": "Kepa Arrizabalaga",
      "team": "AFC Bournemouth",
      "note": ""
    },
    {
      "player": "Illia Zabarnyi",
      "team": "AFC Bournemouth",
      "note": ""
    },
    {
      "player": "Dean Huijsen",
      "team": "AFC Bournemouth",
      "note": ""
    },
    {
      "player": "Julio Soler",
      "team": "AFC Bournemouth",
      "note": "Rookie"
    },
    {
      "player": "Milos Kerkez",
      "team": "AFC Bournemouth",
      "note": ""
    },
    {
      "player": "Tyler Adams",
      "team": "AFC Bournemouth",
      "note": ""
    },
    {
      "player": "Lewis Cook",
      "team": "AFC Bournemouth",
      "note": ""
    },
    {
      "player": "Ryan Christie",
      "team": "AFC Bournemouth",
      "note": ""
    },
    {
      "player": "Luis Sinisterra",
      "team": "AFC Bournemouth",
      "note": ""
    },
    {
      "player": "Antoine Semenyo",
      "team": "AFC Bournemouth",
      "note": ""
    },
    {
      "player": "Justin Kluivert",
      "team": "AFC Bournemouth",
      "note": ""
    },
    {
      "player": "Eli Junior Kroupi",
      "team": "AFC Bournemouth",
      "note": ""
    },
    {
      "player": "Dango Ouattara",
      "team": "AFC Bournemouth",
      "note": ""
    },
    {
      "player": "Evanilson",
      "team": "AFC Bournemouth",
      "note": ""
    },
    {
      "player": "Mark Flekken",
      "team": "Brentford",
      "note": ""
    },
    {
      "player": "Nathan Collins",
      "team": "Brentford",
      "note": ""
    },
    {
      "player": "Sepp van den Berg",
      "team": "Brentford",
      "note": ""
    },
    {
      "player": "Michael Kayode",
      "team": "Brentford",
      "note": ""
    },
    {
      "player": "Christian Nørgaard",
      "team": "Brentford",
      "note": ""
    },
    {
      "player": "Mathias Jensen",
      "team": "Brentford",
      "note": ""
    },
    {
      "player": "Vitaly Janelt",
      "team": "Brentford",
      "note": ""
    },
    {
      "player": "Mikkel Damsgaard",
      "team": "Brentford",
      "note": ""
    },
    {
      "player": "Fábio Carvalho",
      "team": "Brentford",
      "note": ""
    },
    {
      "player": "Kevin Schade",
      "team": "Brentford",
      "note": ""
    },
    {
      "player": "Keane Lewis-Potter",
      "team": "Brentford",
      "note": ""
    },
    {
      "player": "Gustavo Nunes",
      "team": "Brentford",
      "note": "Rookie"
    },
    {
      "player": "Bryan Mbeumo",
      "team": "Brentford",
      "note": ""
    },
    {
      "player": "Yoane Wissa",
      "team": "Brentford",
      "note": ""
    },
    {
      "player": "Bart Verbruggen",
      "team": "Brighton & Hove Albion",
      "note": ""
    },
    {
      "player": "Jan Paul van Hecke",
      "team": "Brighton & Hove Albion",
      "note": ""
    },
    {
      "player": "Pervis Estupiñán",
      "team": "Brighton & Hove Albion",
      "note": ""
    },
    {
      "player": "Lewis Dunk",
      "team": "Brighton & Hove Albion",
      "note": ""
    },
    {
      "player": "Jack Hinshelwood",
      "team": "Brighton & Hove Albion",
      "note": ""
    },
    {
      "player": "Yankuba Minteh",
      "team": "Brighton & Hove Albion",
      "note": ""
    },
    {
      "player": "Carlos Baleba",
      "team": "Brighton & Hove Albion",
      "note": ""
    },
    {
      "player": "Yoon Do-young",
      "team": "Brighton & Hove Albion",
      "note": "Rookie"
    },
    {
      "player": "Yasin Ayari",
      "team": "Brighton & Hove Albion",
      "note": "Rookie"
    },
    {
      "player": "Kaoru Mitoma",
      "team": "Brighton & Hove Albion",
      "note": ""
    },
    {
      "player": "Stefanos Tzimas",
      "team": "Brighton & Hove Albion",
      "note": "Rookie"
    },
    {
      "player": "Danny Welbeck",
      "team": "Brighton & Hove Albion",
      "note": ""
    },
    {
      "player": "Georginio Rutter",
      "team": "Brighton & Hove Albion",
      "note": ""
    },
    {
      "player": "João Pedro",
      "team": "Brighton & Hove Albion",
      "note": ""
    },
    {
      "player": "Robert Sánchez",
      "team": "Chelsea",
      "note": ""
    },
    {
      "player": "Levi Colwill",
      "team": "Chelsea",
      "note": ""
    },
    {
      "player": "Tosin Adarabioyo",
      "team": "Chelsea",
      "note": ""
    },
    {
      "player": "Reece James",
      "team": "Chelsea",
      "note": ""
    },
    {
      "player": "Marc Cucurella",
      "team": "Chelsea",
      "note": ""
    },
    {
      "player": "Harrison Murray-Campbell",
      "team": "Chelsea",
      "note": "Rookie"
    },
    {
      "player": "Moisés Caicedo",
      "team": "Chelsea",
      "note": ""
    },
    {
      "player": "Enzo Fernández",
      "team": "Chelsea",
      "note": ""
    },
    {
      "player": "Cole Palmer",
      "team": "Chelsea",
      "note": ""
    },
    {
      "player": "Kendry Páez",
      "team": "Chelsea",
      "note": "Rookie"
    },
    {
      "player": "Pedro Neto",
      "team": "Chelsea",
      "note": ""
    },
    {
      "player": "Noni Madueke",
      "team": "Chelsea",
      "note": ""
    },
    {
      "player": "Nicolas Jackson",
      "team": "Chelsea",
      "note": ""
    },
    {
      "player": "Estêvão",
      "team": "Chelsea",
      "note": "Rookie"
    },
    {
      "player": "Dean Henderson",
      "team": "Crystal Palace",
      "note": ""
    },
    {
      "player": "Tyrick Mitchell",
      "team": "Crystal Palace",
      "note": ""
    },
    {
      "player": "Chadi Riad",
      "team": "Crystal Palace",
      "note": ""
    },
    {
      "player": "Maxence Lacroix",
      "team": "Crystal Palace",
      "note": ""
    },
    {
      "player": "Marc Guéhi",
      "team": "Crystal Palace",
      "note": ""
    },
    {
      "player": "Chris Richards",
      "team": "Crystal Palace",
      "note": ""
    },
    {
      "player": "Daniel Muñoz",
      "team": "Crystal Palace",
      "note": ""
    },
    {
      "player": "Adam Wharton",
      "team": "Crystal Palace",
      "note": ""
    },
    {
      "player": "Romain Esse",
      "team": "Crystal Palace",
      "note": "Rookie"
    },
    {
      "player": "Daichi Kamada",
      "team": "Crystal Palace",
      "note": ""
    },
    {
      "player": "Eberechi Eze",
      "team": "Crystal Palace",
      "note": ""
    },
    {
      "player": "Ismaïla Sarr",
      "team": "Crystal Palace",
      "note": ""
    },
    {
      "player": "Eddie Nketiah",
      "team": "Crystal Palace",
      "note": ""
    },
    {
      "player": "Jean-Philippe Mateta",
      "team": "Crystal Palace",
      "note": ""
    },
    {
      "player": "Jordan Pickford",
      "team": "Everton",
      "note": ""
    },
    {
      "player": "James Tarkowski",
      "team": "Everton",
      "note": ""
    },
    {
      "player": "Jarrad Branthwaite",
      "team": "Everton",
      "note": ""
    },
    {
      "player": "Vitalii Mykolenko",
      "team": "Everton",
      "note": ""
    },
    {
      "player": "Jake O’Brien",
      "team": "Everton",
      "note": ""
    },
    {
      "player": "Nathan Patterson",
      "team": "Everton",
      "note": ""
    },
    {
      "player": "Roman Dixon",
      "team": "Everton",
      "note": "Rookie"
    },
    {
      "player": "Tim Iroegbunam",
      "team": "Everton",
      "note": ""
    },
    {
      "player": "Harrison Armstrong",
      "team": "Everton",
      "note": "Rookie"
    },
    {
      "player": "James Garner",
      "team": "Everton",
      "note": ""
    },
    {
      "player": "Dwight McNeil",
      "team": "Everton",
      "note": ""
    },
    {
      "player": "Iliman Ndiaye",
      "team": "Everton",
      "note": ""
    },
    {
      "player": "Beto",
      "team": "Everton",
      "note": ""
    },
    {
      "player": "Youssef Chermiti",
      "team": "Everton",
      "note": ""
    },
    {
      "player": "Bernd Leno",
      "team": "Fulham",
      "note": ""
    },
    {
      "player": "Calvin Bassey",
      "team": "Fulham",
      "note": ""
    },
    {
      "player": "Joachim Andersen",
      "team": "Fulham",
      "note": ""
    },
    {
      "player": "Sander Berge",
      "team": "Fulham",
      "note": ""
    },
    {
      "player": "Antonee Robinson",
      "team": "Fulham",
      "note": ""
    },
    {
      "player": "Saša Lukić",
      "team": "Fulham",
      "note": ""
    },
    {
      "player": "Josh King",
      "team": "Fulham",
      "note": "Rookie"
    },
    {
      "player": "Andreas Pereira",
      "team": "Fulham",
      "note": ""
    },
    {
      "player": "Alex Iwobi",
      "team": "Fulham",
      "note": ""
    },
    {
      "player": "Emile Smith Rowe",
      "team": "Fulham",
      "note": ""
    },
    {
      "player": "Harry Wilson",
      "team": "Fulham",
      "note": ""
    },
    {
      "player": "Adama Traoré",
      "team": "Fulham",
      "note": ""
    },
    {
      "player": "Rodrigo Muniz",
      "team": "Fulham",
      "note": ""
    },
    {
      "player": "Raúl Jiménez",
      "team": "Fulham",
      "note": ""
    },
    {
      "player": "Alisson Becker",
      "team": "Liverpool FC",
      "note": ""
    },
    {
      "player": "Virgil van Dijk",
      "team": "Liverpool FC",
      "note": ""
    },
    {
      "player": "Ibrahima Konaté",
      "team": "Liverpool FC",
      "note": ""
    },
    {
      "player": "Andy Robertson",
      "team": "Liverpool FC",
      "note": ""
    },
    {
      "player": "Conor Bradley",
      "team": "Liverpool FC",
      "note": ""
    },
    {
      "player": "Ryan Gravenberch",
      "team": "Liverpool FC",
      "note": ""
    },
    {
      "player": "Alexis Mac Allister",
      "team": "Liverpool FC",
      "note": ""
    },
    {
      "player": "Dominik Szoboszlai",
      "team": "Liverpool FC",
      "note": ""
    },
    {
      "player": "Rio Ngumoha",
      "team": "Liverpool FC",
      "note": "Rookie"
    },
    {
      "player": "Luis Díaz",
      "team": "Liverpool FC",
      "note": ""
    },
    {
      "player": "Mohamed Salah",
      "team": "Liverpool FC",
      "note": ""
    },
    {
      "player": "Cody Gakpo",
      "team": "Liverpool FC",
      "note": ""
    },
    {
      "player": "Diogo Jota",
      "team": "Liverpool FC",
      "note": ""
    },
    {
      "player": "Darwin Núñez",
      "team": "Liverpool FC",
      "note": ""
    },
    {
      "player": "Ederson",
      "team": "Manchester City",
      "note": ""
    },
    {
      "player": "Rúben Dias",
      "team": "Manchester City",
      "note": ""
    },
    {
      "player": "Joško Gvardiol",
      "team": "Manchester City",
      "note": ""
    },
    {
      "player": "Vitor Reis",
      "team": "Manchester City",
      "note": "Rookie"
    },
    {
      "player": "Divine Mukasa",
      "team": "Manchester City",
      "note": "Rookie"
    },
    {
      "player": "Nico González",
      "team": "Manchester City",
      "note": ""
    },
    {
      "player": "Rodri",
      "team": "Manchester City",
      "note": ""
    },
    {
      "player": "Jérémy Doku",
      "team": "Manchester City",
      "note": ""
    },
    {
      "player": "Phil Foden",
      "team": "Manchester City",
      "note": ""
    },
    {
      "player": "Bernardo Silva",
      "team": "Manchester City",
      "note": ""
    },
    {
      "player": "Sávio",
      "team": "Manchester City",
      "note": ""
    },
    {
      "player": "Reigan Heskey",
      "team": "Manchester City",
      "note": "Rookie"
    },
    {
      "player": "Omar Marmoush",
      "team": "Manchester City",
      "note": ""
    },
    {
      "player": "Erling Haaland",
      "team": "Manchester City",
      "note": ""
    },
    {
      "player": "André Onana",
      "team": "Manchester United",
      "note": ""
    },
    {
      "player": "Matthijs de Ligt",
      "team": "Manchester United",
      "note": ""
    },
    {
      "player": "Leny Yoro",
      "team": "Manchester United",
      "note": ""
    },
    {
      "player": "Lisandro Martínez",
      "team": "Manchester United",
      "note": ""
    },
    {
      "player": "Diogo Dalot",
      "team": "Manchester United",
      "note": ""
    },
    {
      "player": "Sékou Koné",
      "team": "Manchester United",
      "note": "Rookie"
    },
    {
      "player": "Kobbie Mainoo",
      "team": "Manchester United",
      "note": ""
    },
    {
      "player": "Manuel Ugarte",
      "team": "Manchester United",
      "note": ""
    },
    {
      "player": "Bruno Fernandes",
      "team": "Manchester United",
      "note": ""
    },
    {
      "player": "Shea Lacey",
      "team": "Manchester United",
      "note": "Rookie"
    },
    {
      "player": "Alejandro Garnacho",
      "team": "Manchester United",
      "note": ""
    },
    {
      "player": "Amad",
      "team": "Manchester United",
      "note": ""
    },
    {
      "player": "Joshua Zirkzee",
      "team": "Manchester United",
      "note": ""
    },
    {
      "player": "Rasmus Højlund",
      "team": "Manchester United",
      "note": ""
    },
    {
      "player": "Nick Pope",
      "team": "Newcastle United",
      "note": ""
    },
    {
      "player": "Dan Burn",
      "team": "Newcastle United",
      "note": ""
    },
    {
      "player": "Sven Botman",
      "team": "Newcastle United",
      "note": ""
    },
    {
      "player": "Fabian Schär",
      "team": "Newcastle United",
      "note": ""
    },
    {
      "player": "Tino Livramento",
      "team": "Newcastle United",
      "note": ""
    },
    {
      "player": "Lewis Hall",
      "team": "Newcastle United",
      "note": ""
    },
    {
      "player": "Lewis Miley",
      "team": "Newcastle United",
      "note": ""
    },
    {
      "player": "Sandro Tonali",
      "team": "Newcastle United",
      "note": ""
    },
    {
      "player": "Joelinton",
      "team": "Newcastle United",
      "note": ""
    },
    {
      "player": "Bruno Guimarães",
      "team": "Newcastle United",
      "note": ""
    },
    {
      "player": "Jacob Murphy",
      "team": "Newcastle United",
      "note": ""
    },
    {
      "player": "Harvey Barnes",
      "team": "Newcastle United",
      "note": ""
    },
    {
      "player": "Anthony Gordon",
      "team": "Newcastle United",
      "note": ""
    },
    {
      "player": "Alexander Isak",
      "team": "Newcastle United",
      "note": ""
    },
    {
      "player": "Matz Sels",
      "team": "Nottingham Forest",
      "note": ""
    },
    {
      "player": "Nikola Milenković",
      "team": "Nottingham Forest",
      "note": ""
    },
    {
      "player": "Ola Aina",
      "team": "Nottingham Forest",
      "note": ""
    },
    {
      "player": "Murillo",
      "team": "Nottingham Forest",
      "note": ""
    },
    {
      "player": "Neco Williams",
      "team": "Nottingham Forest",
      "note": ""
    },
    {
      "player": "Zach Abbott",
      "team": "Nottingham Forest",
      "note": "Rookie"
    },
    {
      "player": "Ryan Yates",
      "team": "Nottingham Forest",
      "note": ""
    },
    {
      "player": "Ibrahim Sangaré",
      "team": "Nottingham Forest",
      "note": ""
    },
    {
      "player": "Elliot Anderson",
      "team": "Nottingham Forest",
      "note": ""
    },
    {
      "player": "Morgan Gibbs-White",
      "team": "Nottingham Forest",
      "note": ""
    },
    {
      "player": "Callum Hudson-Odoi",
      "team": "Nottingham Forest",
      "note": ""
    },
    {
      "player": "Anthony Elanga",
      "team": "Nottingham Forest",
      "note": ""
    },
    {
      "player": "Taiwo Awoniyi",
      "team": "Nottingham Forest",
      "note": ""
    },
    {
      "player": "Chris Wood",
      "team": "Nottingham Forest",
      "note": ""
    },
    {
      "player": "Antonín Kinský",
      "team": "Tottenham Hotspur",
      "note": "Rookie"
    },
    {
      "player": "Pedro Porro",
      "team": "Tottenham Hotspur",
      "note": ""
    },
    {
      "player": "Micky van de Ven",
      "team": "Tottenham Hotspur",
      "note": ""
    },
    {
      "player": "Cristian Romero",
      "team": "Tottenham Hotspur",
      "note": ""
    },
    {
      "player": "Destiny Udogie",
      "team": "Tottenham Hotspur",
      "note": ""
    },
    {
      "player": "Archie Gray",
      "team": "Tottenham Hotspur",
      "note": ""
    },
    {
      "player": "Dejan Kulusevski",
      "team": "Tottenham Hotspur",
      "note": ""
    },
    {
      "player": "Lucas Bergvall",
      "team": "Tottenham Hotspur",
      "note": ""
    },
    {
      "player": "James Maddison",
      "team": "Tottenham Hotspur",
      "note": ""
    },
    {
      "player": "Will Lankshear",
      "team": "Tottenham Hotspur",
      "note": "Rookie"
    },
    {
      "player": "Son Heung-Min",
      "team": "Tottenham Hotspur",
      "note": ""
    },
    {
      "player": "Brennan Johnson",
      "team": "Tottenham Hotspur",
      "note": ""
    },
    {
      "player": "Mikey Moore",
      "team": "Tottenham Hotspur",
      "note": ""
    },
    {
      "player": "Dominic Solanke",
      "team": "Tottenham Hotspur",
      "note": ""
    },
    {
      "player": "Alphonse Areola",
      "team": "West Ham United",
      "note": ""
    },
    {
      "player": "Jean-Clair Todibo",
      "team": "West Ham United",
      "note": ""
    },
    {
      "player": "Maximilian Kilman",
      "team": "West Ham United",
      "note": ""
    },
    {
      "player": "Aaron Wan-Bissaka",
      "team": "West Ham United",
      "note": ""
    },
    {
      "player": "Emerson Palmieri",
      "team": "West Ham United",
      "note": ""
    },
    {
      "player": "Oliver Scarles",
      "team": "West Ham United",
      "note": ""
    },
    {
      "player": "Tomáš Souček",
      "team": "West Ham United",
      "note": ""
    },
    {
      "player": "Edson Álvarez",
      "team": "West Ham United",
      "note": ""
    },
    {
      "player": "Guido Rodríguez",
      "team": "West Ham United",
      "note": ""
    },
    {
      "player": "Mohammed Kudus",
      "team": "West Ham United",
      "note": ""
    },
    {
      "player": "Niclas Füllkrug",
      "team": "West Ham United",
      "note": ""
    },
    {
      "player": "Crysencio Summerville",
      "team": "West Ham United",
      "note": ""
    },
    {
      "player": "Jarrod Bowen",
      "team": "West Ham United",
      "note": ""
    },
    {
      "player": "Luis Guilherme",
      "team": "West Ham United",
      "note": "Rookie"
    },
    {
      "player": "José Sá",
      "team": "Wolverhampton Wanderers",
      "note": ""
    },
    {
      "player": "Nélson Semedo",
      "team": "Wolverhampton Wanderers",
      "note": ""
    },
    {
      "player": "Nasser Djiga",
      "team": "Wolverhampton Wanderers",
      "note": "Rookie"
    },
    {
      "player": "Emmanuel Agbadou",
      "team": "Wolverhampton Wanderers",
      "note": ""
    },
    {
      "player": "Toti Gomes",
      "team": "Wolverhampton Wanderers",
      "note": ""
    },
    {
      "player": "Rayan Aït-Nouri",
      "team": "Wolverhampton Wanderers",
      "note": ""
    },
    {
      "player": "Marshall Munetsi",
      "team": "Wolverhampton Wanderers",
      "note": ""
    },
    {
      "player": "André",
      "team": "Wolverhampton Wanderers",
      "note": ""
    },
    {
      "player": "João Gomes",
      "team": "Wolverhampton Wanderers",
      "note": ""
    },
    {
      "player": "Rodrigo Gomes",
      "team": "Wolverhampton Wanderers",
      "note": ""
    },
    {
      "player": "Gonçalo Guedes",
      "team": "Wolverhampton Wanderers",
      "note": ""
    },
    {
      "player": "Hwang Hee-chan",
      "team": "Wolverhampton Wanderers",
      "note": ""
    },
    {
      "player": "Jørgen Strand Larsen",
      "team": "Wolverhampton Wanderers",
      "note": ""
    },
    {
      "player": "Matheus Cunha",
      "team": "Wolverhampton Wanderers",
      "note": ""
    },
    {
      "player": "James Trafford",
      "team": "Burnley FC",
      "note": ""
    },
    {
      "player": "Maxime Estève",
      "team": "Burnley FC",
      "note": ""
    },
    {
      "player": "Bashir Humphreys",
      "team": "Burnley FC",
      "note": "Rookie"
    },
    {
      "player": "Connor Roberts",
      "team": "Burnley FC",
      "note": ""
    },
    {
      "player": "Lucas Pires",
      "team": "Burnley FC",
      "note": ""
    },
    {
      "player": "Josh Laurent",
      "team": "Burnley FC",
      "note": "Rookie"
    },
    {
      "player": "Josh Cullen",
      "team": "Burnley FC",
      "note": ""
    },
    {
      "player": "Josh Brownhill",
      "team": "Burnley FC",
      "note": ""
    },
    {
      "player": "Hannibal",
      "team": "Burnley FC",
      "note": ""
    },
    {
      "player": "Marcus Edwards",
      "team": "Burnley FC",
      "note": ""
    },
    {
      "player": "Lyle Foster",
      "team": "Burnley FC",
      "note": ""
    },
    {
      "player": "Luca Koleosho",
      "team": "Burnley FC",
      "note": ""
    },
    {
      "player": "Jaidon Anthony",
      "team": "Burnley FC",
      "note": ""
    },
    {
      "player": "Jaydon Banel",
      "team": "Burnley FC",
      "note": "Rookie"
    },
    {
      "player": "Illan Meslier",
      "team": "Leeds United",
      "note": ""
    },
    {
      "player": "Joe Rodon",
      "team": "Leeds United",
      "note": ""
    },
    {
      "player": "Pascal Struijk",
      "team": "Leeds United",
      "note": ""
    },
    {
      "player": "Jayden Bogle",
      "team": "Leeds United",
      "note": ""
    },
    {
      "player": "Ethan Ampadu",
      "team": "Leeds United",
      "note": ""
    },
    {
      "player": "Ao Tanaka",
      "team": "Leeds United",
      "note": ""
    },
    {
      "player": "Brenden Aaronson",
      "team": "Leeds United",
      "note": ""
    },
    {
      "player": "Ilia Gruev",
      "team": "Leeds United",
      "note": ""
    },
    {
      "player": "Harry Gray",
      "team": "Leeds United",
      "note": "Rookie"
    },
    {
      "player": "Mateo Joseph",
      "team": "Leeds United",
      "note": "Rookie"
    },
    {
      "player": "Wilfried Gnonto",
      "team": "Leeds United",
      "note": ""
    },
    {
      "player": "Daniel James",
      "team": "Leeds United",
      "note": ""
    },
    {
      "player": "Patrick Bamford",
      "team": "Leeds United",
      "note": ""
    },
    {
      "player": "Joël Piroe",
      "team": "Leeds United",
      "note": "Rookie"
    },
    {
      "player": "Anthony Patterson",
      "team": "Sunderland",
      "note": "Rookie"
    },
    {
      "player": "Trai Hume",
      "team": "Sunderland",
      "note": "Rookie"
    },
    {
      "player": "Dennis Cirkin",
      "team": "Sunderland",
      "note": "Rookie"
    },
    {
      "player": "Luke O’Nien",
      "team": "Sunderland",
      "note": "Rookie"
    },
    {
      "player": "Daniel Ballard",
      "team": "Sunderland",
      "note": "Rookie"
    },
    {
      "player": "Chris Rigg",
      "team": "Sunderland",
      "note": "Rookie"
    },
    {
      "player": "Dan Neil",
      "team": "Sunderland",
      "note": "Rookie"
    },
    {
      "player": "Alan Browne",
      "team": "Sunderland",
      "note": "Rookie"
    },
    {
      "player": "Jobe Bellingham",
      "team": "Sunderland",
      "note": "Rookie"
    },
    {
      "player": "Enzo Le Fée",
      "team": "Sunderland",
      "note": ""
    },
    {
      "player": "Romaine Mundle",
      "team": "Sunderland",
      "note": "Rookie"
    },
    {
      "player": "Patrick Roberts",
      "team": "Sunderland",
      "note": ""
    },
    {
      "player": "Eliezer Mayenda",
      "team": "Sunderland",
      "note": "Rookie"
    },
    {
      "player": "Wilson Isidor",
      "team": "Sunderland",
      "note": "Rookie"
    },
    {
      "player": "Aston Villa",
      "team": "Arsenal",
      "note": "AFC Bournemouth"
    },
    {
      "player": "Brighton & Hove Albion",
      "team": "Brentford",
      "note": "Chelsea"
    },
    {
      "player": "Everton",
      "team": "Crystal Palace",
      "note": "Fulham"
    },
    {
      "player": "Manchester United",
      "team": "Manchester City",
      "note": "Newcastle United"
    },
    {
      "player": "Tottenham Hotspur",
      "team": "Nottingham Forest",
      "note": "West Ham United"
    },
    {
      "player": "Burnley FC",
      "team": "Wolverhampton Wanderers",
      "note": "Leeds United"
    },
    {
      "player": "Team Badge",
      "team": "Arsenal",
      "note": ""
    },
    {
      "player": "Team Badge",
      "team": "Aston Villa",
      "note": ""
    },
    {
      "player": "Team Badge",
      "team": "AFC Bournemouth",
      "note": ""
    },
    {
      "player": "Team Badge",
      "team": "Brentford",
      "note": ""
    },
    {
      "player": "Team Badge",
      "team": "Brighton & Hove Albion",
      "note": ""
    },
    {
      "player": "Team Badge",
      "team": "Chelsea",
      "note": ""
    },
    {
      "player": "Team Badge",
      "team": "Crystal Palace",
      "note": ""
    },
    {
      "player": "Team Badge",
      "team": "Everton",
      "note": ""
    },
    {
      "player": "Team Badge",
      "team": "Fulham",
      "note": ""
    },
    {
      "player": "Team Badge",
      "team": "Manchester City",
      "note": ""
    },
    {
      "player": "Team Badge",
      "team": "Manchester United",
      "note": ""
    },
    {
      "player": "Team Badge",
      "team": "Newcastle United",
      "note": ""
    },
    {
      "player": "Team Badge",
      "team": "Nottingham Forest",
      "note": ""
    },
    {
      "player": "Team Badge",
      "team": "Tottenham Hotspur",
      "note": ""
    },
    {
      "player": "Team Badge",
      "team": "West Ham United",
      "note": ""
    },
    {
      "player": "Team Badge",
      "team": "Wolverhampton Wanderers",
      "note": ""
    },
    {
      "player": "Team Badge",
      "team": "Burnley FC",
      "note": ""
    },
    {
      "player": "Team Badge",
      "team": "Leeds United",
      "note": ""
    },
    {
      "player": "Team Badge",
      "team": "Sunderland",
      "note": ""
    }
  ],
  "baseImageVariation": [
    {
      "player": "Declan Rice",
      "team": "Arsenal",
      "note": ""
    },
    {
      "player": "Estêvão",
      "team": "Chelsea",
      "note": "Rookie"
    },
    {
      "player": "Rio Ngumoha",
      "team": "Liverpool FC",
      "note": "Rookie"
    },
    {
      "player": "Sávio",
      "team": "Manchester City",
      "note": ""
    },
    {
      "player": "Amad",
      "team": "Manchester United",
      "note": ""
    }
  ],
  "generationNow": [
    {
      "player": "Gabriel Martinelli",
      "team": "Arsenal",
      "note": ""
    },
    {
      "player": "Boubacar Kamara",
      "team": "Aston Villa",
      "note": ""
    },
    {
      "player": "Milos Kerkez",
      "team": "AFC Bournemouth",
      "note": ""
    },
    {
      "player": "Fábio Carvalho",
      "team": "Brentford",
      "note": ""
    },
    {
      "player": "Matt O’Riley",
      "team": "Brighton & Hove Albion",
      "note": ""
    },
    {
      "player": "Levi Colwill",
      "team": "Chelsea",
      "note": ""
    },
    {
      "player": "Marc Guéhi",
      "team": "Crystal Palace",
      "note": ""
    },
    {
      "player": "Iliman Ndiaye",
      "team": "Everton",
      "note": ""
    },
    {
      "player": "Rodrigo Muniz",
      "team": "Fulham",
      "note": ""
    },
    {
      "player": "Dominik Szoboszlai",
      "team": "Liverpool FC",
      "note": ""
    },
    {
      "player": "Jérémy Doku",
      "team": "Manchester City",
      "note": ""
    },
    {
      "player": "Kobbie Mainoo",
      "team": "Manchester United",
      "note": ""
    },
    {
      "player": "Tino Livramento",
      "team": "Newcastle United",
      "note": ""
    },
    {
      "player": "Murillo",
      "team": "Nottingham Forest",
      "note": ""
    },
    {
      "player": "Lucas Bergvall",
      "team": "Tottenham Hotspur",
      "note": ""
    },
    {
      "player": "Crysencio Summerville",
      "team": "West Ham United",
      "note": ""
    },
    {
      "player": "João Gomes",
      "team": "Wolverhampton Wanderers",
      "note": ""
    },
    {
      "player": "Lucas Pires",
      "team": "Burnley FC",
      "note": ""
    },
    {
      "player": "Mateo Joseph",
      "team": "Leeds United",
      "note": "Rookie"
    },
    {
      "player": "Jobe Bellingham",
      "team": "Sunderland",
      "note": "Rookie"
    }
  ],
  "fullForce": [
    {
      "player": "Jurriën Timber",
      "team": "Arsenal",
      "note": ""
    },
    {
      "player": "John McGinn",
      "team": "Aston Villa",
      "note": ""
    },
    {
      "player": "Illia Zabarnyi",
      "team": "AFC Bournemouth",
      "note": ""
    },
    {
      "player": "Gustavo Nunes",
      "team": "Brentford",
      "note": "Rookie"
    },
    {
      "player": "Carlos Baleba",
      "team": "Brighton & Hove Albion",
      "note": ""
    },
    {
      "player": "Marc Cucurella",
      "team": "Chelsea",
      "note": ""
    },
    {
      "player": "Tyrick Mitchell",
      "team": "Crystal Palace",
      "note": ""
    },
    {
      "player": "Vitalii Mykolenko",
      "team": "Everton",
      "note": ""
    },
    {
      "player": "Calvin Bassey",
      "team": "Fulham",
      "note": ""
    },
    {
      "player": "Darwin Núñez",
      "team": "Liverpool FC",
      "note": ""
    },
    {
      "player": "Joško Gvardiol",
      "team": "Manchester City",
      "note": ""
    },
    {
      "player": "Manuel Ugarte",
      "team": "Manchester United",
      "note": ""
    },
    {
      "player": "Joelinton",
      "team": "Newcastle United",
      "note": ""
    },
    {
      "player": "Ola Aina",
      "team": "Nottingham Forest",
      "note": ""
    },
    {
      "player": "Mikey Moore",
      "team": "Tottenham Hotspur",
      "note": ""
    },
    {
      "player": "Aaron Wan-Bissaka",
      "team": "West Ham United",
      "note": ""
    },
    {
      "player": "Nasser Djiga",
      "team": "Wolverhampton Wanderers",
      "note": "Rookie"
    },
    {
      "player": "Josh Cullen",
      "team": "Burnley FC",
      "note": ""
    },
    {
      "player": "Pascal Struijk",
      "team": "Leeds United",
      "note": ""
    },
    {
      "player": "Wilson Isidor",
      "team": "Sunderland",
      "note": "Rookie"
    }
  ],
  "breakthroughBallers": [
    {
      "player": "Myles Lewis-Skelly",
      "team": "Arsenal",
      "note": ""
    },
    {
      "player": "Josh King",
      "team": "Fulham",
      "note": "Rookie"
    },
    {
      "player": "Patrick Dorgu",
      "team": "Manchester United",
      "note": ""
    },
    {
      "player": "Lewis Miley",
      "team": "Newcastle United",
      "note": ""
    },
    {
      "player": "Archie Gray",
      "team": "Tottenham Hotspur",
      "note": ""
    },
    {
      "player": "Luis Guilherme",
      "team": "West Ham United",
      "note": "Rookie"
    },
    {
      "player": "André",
      "team": "Wolverhampton Wanderers",
      "note": ""
    },
    {
      "player": "Luca Koleosho",
      "team": "Burnley FC",
      "note": ""
    },
    {
      "player": "Harry Gray",
      "team": "Leeds United",
      "note": "Rookie"
    },
    {
      "player": "Chris Rigg",
      "team": "Sunderland",
      "note": "Rookie"
    }
  ],
  "tekkers": [
    {
      "player": "Donyell Malen",
      "team": "Aston Villa",
      "note": ""
    },
    {
      "player": "Justin Kluivert",
      "team": "AFC Bournemouth",
      "note": ""
    },
    {
      "player": "Kevin Schade",
      "team": "Brentford",
      "note": ""
    },
    {
      "player": "Matt O’Riley",
      "team": "Brighton & Hove Albion",
      "note": ""
    },
    {
      "player": "Noni Madueke",
      "team": "Chelsea",
      "note": ""
    },
    {
      "player": "Ismaïla Sarr",
      "team": "Crystal Palace",
      "note": ""
    },
    {
      "player": "Iliman Ndiaye",
      "team": "Everton",
      "note": ""
    },
    {
      "player": "Luis Díaz",
      "team": "Liverpool FC",
      "note": ""
    },
    {
      "player": "Sávio",
      "team": "Manchester City",
      "note": ""
    },
    {
      "player": "Anthony Elanga",
      "team": "Nottingham Forest",
      "note": ""
    }
  ],
  "proPartnerships": [
    {
      "player": "William Saliba",
      "team": "Arsenal",
      "note": ""
    },
    {
      "player": "Gabriel Magalhães",
      "team": "Arsenal",
      "note": ""
    },
    {
      "player": "Youri Tielemans",
      "team": "Aston Villa",
      "note": ""
    },
    {
      "player": "Amadou Onana",
      "team": "Aston Villa",
      "note": ""
    },
    {
      "player": "Dango Ouattara",
      "team": "AFC Bournemouth",
      "note": ""
    },
    {
      "player": "Antoine Semenyo",
      "team": "AFC Bournemouth",
      "note": ""
    },
    {
      "player": "Sepp van den Berg",
      "team": "Brentford",
      "note": ""
    },
    {
      "player": "Nathan Collins",
      "team": "Brentford",
      "note": ""
    },
    {
      "player": "Simon Adingra",
      "team": "Brighton & Hove Albion",
      "note": ""
    },
    {
      "player": "Kaoru Mitoma",
      "team": "Brighton & Hove Albion",
      "note": ""
    },
    {
      "player": "John Terry",
      "team": "Chelsea",
      "note": ""
    },
    {
      "player": "Enzo Fernández",
      "team": "Chelsea",
      "note": ""
    },
    {
      "player": "Moisés Caicedo",
      "team": "Chelsea",
      "note": ""
    },
    {
      "player": "Adam Wharton",
      "team": "Crystal Palace",
      "note": ""
    },
    {
      "player": "Daichi Kamada",
      "team": "Crystal Palace",
      "note": ""
    },
    {
      "player": "James Tarkowski",
      "team": "Everton",
      "note": ""
    },
    {
      "player": "Jarrad Branthwaite",
      "team": "Everton",
      "note": ""
    },
    {
      "player": "Enzo Le Fée",
      "team": "Sunderland",
      "note": ""
    },
    {
      "player": "Patrick Roberts",
      "team": "Sunderland",
      "note": ""
    },
    {
      "player": "Ryan Gravenberch",
      "team": "Liverpool FC",
      "note": ""
    },
    {
      "player": "Alexis Mac Allister",
      "team": "Liverpool FC",
      "note": ""
    },
    {
      "player": "Phil Foden",
      "team": "Manchester City",
      "note": ""
    },
    {
      "player": "Bernardo Silva",
      "team": "Manchester City",
      "note": ""
    },
    {
      "player": "Rasmus Højlund",
      "team": "Manchester United",
      "note": ""
    },
    {
      "player": "Bruno Fernandes",
      "team": "Manchester United",
      "note": ""
    },
    {
      "player": "Joelinton",
      "team": "Newcastle United",
      "note": ""
    },
    {
      "player": "Bruno Guimarães",
      "team": "Newcastle United",
      "note": ""
    },
    {
      "player": "Callum Hudson-Odoi",
      "team": "Nottingham Forest",
      "note": ""
    },
    {
      "player": "Ola Aina",
      "team": "Nottingham Forest",
      "note": ""
    },
    {
      "player": "Brennan Johnson",
      "team": "Tottenham Hotspur",
      "note": ""
    },
    {
      "player": "Dejan Kulusevski",
      "team": "Tottenham Hotspur",
      "note": ""
    },
    {
      "player": "Teddy Sheringham",
      "team": "Tottenham Hotspur",
      "note": ""
    },
    {
      "player": "Darren Anderton",
      "team": "Tottenham Hotspur",
      "note": ""
    },
    {
      "player": "Gonçalo Guedes",
      "team": "Wolverhampton Wanderers",
      "note": ""
    },
    {
      "player": "Jørgen Strand Larsen",
      "team": "Wolverhampton Wanderers",
      "note": ""
    },
    {
      "player": "Lucas Pires",
      "team": "Burnley FC",
      "note": ""
    },
    {
      "player": "Maxime Estève",
      "team": "Burnley FC",
      "note": ""
    },
    {
      "player": "Joe Rodon",
      "team": "Leeds United",
      "note": ""
    },
    {
      "player": "Ethan Ampadu",
      "team": "Leeds United",
      "note": ""
    }
  ],
  "retroThreads": [
    {
      "player": "Ian Wright",
      "team": "Arsenal",
      "note": ""
    },
    {
      "player": "Stiliyan Petrov",
      "team": "Aston Villa",
      "note": ""
    },
    {
      "player": "Simon Francis",
      "team": "AFC Bournemouth",
      "note": ""
    },
    {
      "player": "Eric Cantona",
      "team": "Manchester United",
      "note": ""
    },
    {
      "player": "Christian Nørgaard",
      "team": "Brentford",
      "note": ""
    },
    {
      "player": "Glenn Murray",
      "team": "Brighton & Hove Albion",
      "note": ""
    },
    {
      "player": "Frank Lampard",
      "team": "Chelsea",
      "note": ""
    },
    {
      "player": "Andrew Johnson",
      "team": "Crystal Palace",
      "note": ""
    },
    {
      "player": "Joleon Lescott",
      "team": "Everton",
      "note": ""
    },
    {
      "player": "Louis Saha",
      "team": "Fulham",
      "note": ""
    },
    {
      "player": "Jamie Carragher",
      "team": "Liverpool FC",
      "note": ""
    },
    {
      "player": "Micah Richards",
      "team": "Manchester City",
      "note": ""
    },
    {
      "player": "Gary Neville",
      "team": "Manchester United",
      "note": ""
    },
    {
      "player": "Faustino Asprilla",
      "team": "Newcastle United",
      "note": ""
    },
    {
      "player": "Stan Collymore",
      "team": "Nottingham Forest",
      "note": ""
    },
    {
      "player": "Robbie Keane",
      "team": "Tottenham Hotspur",
      "note": ""
    },
    {
      "player": "Mark Noble",
      "team": "West Ham United",
      "note": ""
    },
    {
      "player": "Kevin Doyle",
      "team": "Wolverhampton Wanderers",
      "note": ""
    },
    {
      "player": "Aaron Lennon",
      "team": "Burnley FC",
      "note": ""
    },
    {
      "player": "Jimmy Floyd Hasselbaink",
      "team": "Leeds United",
      "note": ""
    }
  ],
  "proPrecision": [
    {
      "player": "Kai Havertz",
      "team": "Arsenal",
      "note": ""
    },
    {
      "player": "Ollie Watkins",
      "team": "Aston Villa",
      "note": ""
    },
    {
      "player": "Dango Ouattara",
      "team": "AFC Bournemouth",
      "note": ""
    },
    {
      "player": "Mikkel Damsgaard",
      "team": "Brentford",
      "note": ""
    },
    {
      "player": "Danny Welbeck",
      "team": "Brighton & Hove Albion",
      "note": ""
    },
    {
      "player": "Nicolas Jackson",
      "team": "Chelsea",
      "note": ""
    },
    {
      "player": "Eddie Nketiah",
      "team": "Crystal Palace",
      "note": ""
    },
    {
      "player": "Beto",
      "team": "Everton",
      "note": ""
    },
    {
      "player": "Robbie Fowler",
      "team": "Liverpool FC",
      "note": ""
    },
    {
      "player": "Diogo Jota",
      "team": "Liverpool FC",
      "note": ""
    },
    {
      "player": "Phil Foden",
      "team": "Manchester City",
      "note": ""
    },
    {
      "player": "Bruno Fernandes",
      "team": "Manchester United",
      "note": ""
    },
    {
      "player": "Wayne Rooney",
      "team": "Manchester United",
      "note": ""
    },
    {
      "player": "Anthony Gordon",
      "team": "Newcastle United",
      "note": ""
    },
    {
      "player": "Taiwo Awoniyi",
      "team": "Nottingham Forest",
      "note": ""
    },
    {
      "player": "Brennan Johnson",
      "team": "Tottenham Hotspur",
      "note": ""
    },
    {
      "player": "Mohammed Kudus",
      "team": "West Ham United",
      "note": ""
    },
    {
      "player": "Jørgen Strand Larsen",
      "team": "Wolverhampton Wanderers",
      "note": ""
    },
    {
      "player": "Josh Brownhill",
      "team": "Burnley FC",
      "note": ""
    },
    {
      "player": "Patrick Bamford",
      "team": "Leeds United",
      "note": ""
    }
  ],
  "beastMode": [
    {
      "player": "Declan Rice",
      "team": "Arsenal",
      "note": ""
    },
    {
      "player": "Morgan Rogers",
      "team": "Aston Villa",
      "note": ""
    },
    {
      "player": "Evanilson",
      "team": "AFC Bournemouth",
      "note": ""
    },
    {
      "player": "Yoane Wissa",
      "team": "Brentford",
      "note": ""
    },
    {
      "player": "Georginio Rutter",
      "team": "Brighton & Hove Albion",
      "note": ""
    },
    {
      "player": "Enzo Fernández",
      "team": "Chelsea",
      "note": ""
    },
    {
      "player": "Jean-Philippe Mateta",
      "team": "Crystal Palace",
      "note": ""
    },
    {
      "player": "Beto",
      "team": "Everton",
      "note": ""
    },
    {
      "player": "Virgil van Dijk",
      "team": "Liverpool FC",
      "note": ""
    },
    {
      "player": "Rodri",
      "team": "Manchester City",
      "note": ""
    },
    {
      "player": "Alejandro Garnacho",
      "team": "Manchester United",
      "note": ""
    },
    {
      "player": "Sandro Tonali",
      "team": "Newcastle United",
      "note": ""
    },
    {
      "player": "Chris Wood",
      "team": "Nottingham Forest",
      "note": ""
    },
    {
      "player": "Ledley King",
      "team": "Tottenham Hotspur",
      "note": ""
    },
    {
      "player": "Dominic Solanke",
      "team": "Tottenham Hotspur",
      "note": ""
    },
    {
      "player": "Emerson Palmieri",
      "team": "West Ham United",
      "note": ""
    },
    {
      "player": "Hwang Hee-chan",
      "team": "Wolverhampton Wanderers",
      "note": ""
    },
    {
      "player": "Hannibal",
      "team": "Burnley FC",
      "note": ""
    },
    {
      "player": "Daniel James",
      "team": "Leeds United",
      "note": ""
    }
  ],
  "headliners": [
    {
      "player": "Martin Ødegaard",
      "team": "Arsenal",
      "note": ""
    },
    {
      "player": "Emiliano Martínez",
      "team": "Aston Villa",
      "note": ""
    },
    {
      "player": "Kevin Schade",
      "team": "Brentford",
      "note": ""
    },
    {
      "player": "Pedro Neto",
      "team": "Chelsea",
      "note": ""
    },
    {
      "player": "Jordan Pickford",
      "team": "Everton",
      "note": ""
    },
    {
      "player": "Cody Gakpo",
      "team": "Liverpool FC",
      "note": ""
    },
    {
      "player": "Jérémy Doku",
      "team": "Manchester City",
      "note": ""
    },
    {
      "player": "Amad",
      "team": "Manchester United",
      "note": ""
    },
    {
      "player": "Jacob Murphy",
      "team": "Newcastle United",
      "note": ""
    },
    {
      "player": "James Maddison",
      "team": "Tottenham Hotspur",
      "note": ""
    }
  ],
  "chromeKings": [
    {
      "player": "Cesc Fàbregas",
      "team": "Arsenal",
      "note": ""
    },
    {
      "player": "Dwight Yorke",
      "team": "Aston Villa",
      "note": ""
    },
    {
      "player": "Adam Smith",
      "team": "AFC Bournemouth",
      "note": ""
    },
    {
      "player": "Christian Nørgaard",
      "team": "Brentford",
      "note": ""
    },
    {
      "player": "Lewis Dunk",
      "team": "Brighton & Hove Albion",
      "note": ""
    },
    {
      "player": "Gianfranco Zola",
      "team": "Chelsea",
      "note": ""
    },
    {
      "player": "Didier Drogba",
      "team": "Chelsea",
      "note": ""
    },
    {
      "player": "Nathaniel Clyne",
      "team": "Crystal Palace",
      "note": ""
    },
    {
      "player": "Séamus Coleman",
      "team": "Everton",
      "note": ""
    },
    {
      "player": "Clint Dempsey",
      "team": "Fulham",
      "note": ""
    },
    {
      "player": "Xabi Alonso",
      "team": "Liverpool FC",
      "note": ""
    },
    {
      "player": "Steven Gerrard",
      "team": "Liverpool FC",
      "note": ""
    },
    {
      "player": "David Silva",
      "team": "Manchester City",
      "note": ""
    },
    {
      "player": "Sergio Agüero",
      "team": "Manchester City",
      "note": ""
    },
    {
      "player": "Nemanja Vidić",
      "team": "Manchester United",
      "note": ""
    },
    {
      "player": "Andy Cole",
      "team": "Newcastle United",
      "note": ""
    },
    {
      "player": "Roy Keane",
      "team": "Nottingham Forest",
      "note": ""
    },
    {
      "player": "Gareth Bale",
      "team": "Tottenham Hotspur",
      "note": ""
    },
    {
      "player": "Bobby Zamora",
      "team": "West Ham United",
      "note": ""
    },
    {
      "player": "Paul Ince",
      "team": "Wolverhampton Wanderers",
      "note": ""
    }
  ],
  "diamondRookies": [
    {
      "player": "Julio Soler",
      "team": "AFC Bournemouth",
      "note": "Rookie"
    },
    {
      "player": "Stefanos Tzimas",
      "team": "Brighton & Hove Albion",
      "note": "Rookie"
    },
    {
      "player": "Kendry Páez",
      "team": "Chelsea",
      "note": "Rookie"
    },
    {
      "player": "Estêvão",
      "team": "Chelsea",
      "note": "Rookie"
    },
    {
      "player": "Romain Esse",
      "team": "Crystal Palace",
      "note": "Rookie"
    },
    {
      "player": "Rio Ngumoha",
      "team": "Liverpool FC",
      "note": "Rookie"
    },
    {
      "player": "Claudio Echeverri",
      "team": "Manchester City",
      "note": "Rookie"
    },
    {
      "player": "Reigan Heskey",
      "team": "Manchester City",
      "note": "Rookie"
    },
    {
      "player": "Sékou Koné",
      "team": "Manchester United",
      "note": "Rookie"
    },
    {
      "player": "Shea Lacey",
      "team": "Manchester United",
      "note": "Rookie"
    }
  ],
  "goldLions": [
    {
      "player": "Bukayo Saka",
      "team": "Arsenal",
      "note": ""
    },
    {
      "player": "Ollie Watkins",
      "team": "Aston Villa",
      "note": ""
    },
    {
      "player": "Evanilson",
      "team": "AFC Bournemouth",
      "note": ""
    },
    {
      "player": "Bryan Mbeumo",
      "team": "Brentford",
      "note": ""
    },
    {
      "player": "Kaoru Mitoma",
      "team": "Brighton & Hove Albion",
      "note": ""
    },
    {
      "player": "Cole Palmer",
      "team": "Chelsea",
      "note": ""
    },
    {
      "player": "Eden Hazard",
      "team": "Chelsea",
      "note": ""
    },
    {
      "player": "Eberechi Eze",
      "team": "Crystal Palace",
      "note": ""
    },
    {
      "player": "Iliman Ndiaye",
      "team": "Everton",
      "note": ""
    },
    {
      "player": "Amad",
      "team": "Manchester United",
      "note": ""
    },
    {
      "player": "Mohamed Salah",
      "team": "Liverpool FC",
      "note": ""
    },
    {
      "player": "Erling Haaland",
      "team": "Manchester City",
      "note": ""
    },
    {
      "player": "Alejandro Garnacho",
      "team": "Manchester United",
      "note": ""
    },
    {
      "player": "Alexander Isak",
      "team": "Newcastle United",
      "note": ""
    },
    {
      "player": "Morgan Gibbs-White",
      "team": "Nottingham Forest",
      "note": ""
    },
    {
      "player": "Son Heung-Min",
      "team": "Tottenham Hotspur",
      "note": ""
    },
    {
      "player": "Jarrod Bowen",
      "team": "West Ham United",
      "note": ""
    },
    {
      "player": "Matheus Cunha",
      "team": "Wolverhampton Wanderers",
      "note": ""
    },
    {
      "player": "Josh Brownhill",
      "team": "Burnley FC",
      "note": ""
    },
    {
      "player": "Ao Tanaka",
      "team": "Leeds United",
      "note": ""
    }
  ],
  "premierPull": [
    {
      "player": "Declan Rice",
      "team": "Arsenal",
      "note": ""
    },
    {
      "player": "Jacob Ramsey",
      "team": "Aston Villa",
      "note": ""
    },
    {
      "player": "Justin Kluivert",
      "team": "AFC Bournemouth",
      "note": ""
    },
    {
      "player": "Gustavo Nunes",
      "team": "Brentford",
      "note": "Rookie"
    },
    {
      "player": "Stefanos Tzimas",
      "team": "Brighton & Hove Albion",
      "note": "Rookie"
    },
    {
      "player": "Estêvão",
      "team": "Chelsea",
      "note": "Rookie"
    },
    {
      "player": "Marc Guéhi",
      "team": "Crystal Palace",
      "note": ""
    },
    {
      "player": "Jarrad Branthwaite",
      "team": "Everton",
      "note": ""
    },
    {
      "player": "John Terry",
      "team": "Chelsea",
      "note": ""
    },
    {
      "player": "Cody Gakpo",
      "team": "Liverpool FC",
      "note": ""
    },
    {
      "player": "Abdukodir Khusanov",
      "team": "Manchester City",
      "note": ""
    },
    {
      "player": "Nico González",
      "team": "Manchester City",
      "note": ""
    },
    {
      "player": "Kobbie Mainoo",
      "team": "Manchester United",
      "note": ""
    },
    {
      "player": "Eric Cantona",
      "team": "Manchester United",
      "note": ""
    },
    {
      "player": "Bruno Guimarães",
      "team": "Newcastle United",
      "note": ""
    },
    {
      "player": "Zach Abbott",
      "team": "Nottingham Forest",
      "note": "Rookie"
    },
    {
      "player": "Lucas Bergvall",
      "team": "Tottenham Hotspur",
      "note": ""
    },
    {
      "player": "Gonçalo Guedes",
      "team": "Wolverhampton Wanderers",
      "note": ""
    },
    {
      "player": "James Trafford",
      "team": "Burnley FC",
      "note": ""
    },
    {
      "player": "Joël Piroe",
      "team": "Leeds United",
      "note": "Rookie"
    }
  ],
  "baseAutos": [
    {
      "player": "Dango Ouattara",
      "team": "AFC Bournemouth",
      "note": ""
    },
    {
      "player": "Evanilson",
      "team": "AFC Bournemouth",
      "note": ""
    },
    {
      "player": "Tyler Adams",
      "team": "AFC Bournemouth",
      "note": ""
    },
    {
      "player": "David Raya",
      "team": "Arsenal",
      "note": ""
    },
    {
      "player": "William Saliba",
      "team": "Arsenal",
      "note": ""
    },
    {
      "player": "Mikel Merino",
      "team": "Arsenal",
      "note": ""
    },
    {
      "player": "Declan Rice",
      "team": "Arsenal",
      "note": ""
    },
    {
      "player": "Myles Lewis-Skelly",
      "team": "Arsenal",
      "note": ""
    },
    {
      "player": "Martin Ødegaard",
      "team": "Arsenal",
      "note": ""
    },
    {
      "player": "Ethan Nwaneri",
      "team": "Arsenal",
      "note": ""
    },
    {
      "player": "Bukayo Saka",
      "team": "Arsenal",
      "note": ""
    },
    {
      "player": "Gabriel Martinelli",
      "team": "Arsenal",
      "note": ""
    },
    {
      "player": "Leandro Trossard",
      "team": "Arsenal",
      "note": ""
    },
    {
      "player": "Kai Havertz",
      "team": "Arsenal",
      "note": ""
    },
    {
      "player": "Donyell Malen",
      "team": "Aston Villa",
      "note": ""
    },
    {
      "player": "Emiliano Martínez",
      "team": "Aston Villa",
      "note": ""
    },
    {
      "player": "Jacob Ramsey",
      "team": "Aston Villa",
      "note": ""
    },
    {
      "player": "Matty Cash",
      "team": "Aston Villa",
      "note": ""
    },
    {
      "player": "Ollie Watkins",
      "team": "Aston Villa",
      "note": ""
    },
    {
      "player": "Stiliyan Petrov",
      "team": "Aston Villa",
      "note": ""
    },
    {
      "player": "Fábio Carvalho",
      "team": "Brentford",
      "note": ""
    },
    {
      "player": "Kristoffer Ajer",
      "team": "Brentford",
      "note": ""
    },
    {
      "player": "Kevin Schade",
      "team": "Brentford",
      "note": ""
    },
    {
      "player": "Nathan Collins",
      "team": "Brentford",
      "note": ""
    },
    {
      "player": "Yehor Yarmoliuk",
      "team": "Brentford",
      "note": ""
    },
    {
      "player": "Evan Ferguson",
      "team": "Brighton & Hove Albion",
      "note": ""
    },
    {
      "player": "Georginio Rutter",
      "team": "Brighton & Hove Albion",
      "note": ""
    },
    {
      "player": "João Pedro",
      "team": "Brighton & Hove Albion",
      "note": ""
    },
    {
      "player": "Lewis Dunk",
      "team": "Brighton & Hove Albion",
      "note": ""
    },
    {
      "player": "Matt O’Riley",
      "team": "Brighton & Hove Albion",
      "note": ""
    },
    {
      "player": "Simon Adingra",
      "team": "Brighton & Hove Albion",
      "note": ""
    },
    {
      "player": "Yasin Ayari",
      "team": "Brighton & Hove Albion",
      "note": "Rookie"
    },
    {
      "player": "Yankuba Minteh",
      "team": "Brighton & Hove Albion",
      "note": ""
    },
    {
      "player": "Ashley Cole",
      "team": "Chelsea",
      "note": ""
    },
    {
      "player": "César Azpilicueta",
      "team": "Chelsea",
      "note": ""
    },
    {
      "player": "Cole Palmer",
      "team": "Chelsea",
      "note": ""
    },
    {
      "player": "Diego Costa",
      "team": "Chelsea",
      "note": ""
    },
    {
      "player": "Enzo Fernández",
      "team": "Chelsea",
      "note": ""
    },
    {
      "player": "Estêvão",
      "team": "Chelsea",
      "note": "Rookie"
    },
    {
      "player": "Juan Mata",
      "team": "Chelsea",
      "note": ""
    },
    {
      "player": "John Terry",
      "team": "Chelsea",
      "note": ""
    },
    {
      "player": "Levi Colwill",
      "team": "Chelsea",
      "note": ""
    },
    {
      "player": "Michael Ballack",
      "team": "Chelsea",
      "note": ""
    },
    {
      "player": "Nicolas Anelka",
      "team": "Chelsea",
      "note": ""
    },
    {
      "player": "Nicolas Jackson",
      "team": "Chelsea",
      "note": ""
    },
    {
      "player": "Noni Madueke",
      "team": "Chelsea",
      "note": ""
    },
    {
      "player": "Reece James",
      "team": "Chelsea",
      "note": ""
    },
    {
      "player": "Tosin Adarabioyo",
      "team": "Chelsea",
      "note": ""
    },
    {
      "player": "Tore André Flo",
      "team": "Chelsea",
      "note": ""
    },
    {
      "player": "Trevoh Chalobah",
      "team": "Chelsea",
      "note": ""
    },
    {
      "player": "Adam Wharton",
      "team": "Crystal Palace",
      "note": ""
    },
    {
      "player": "Chris Richards",
      "team": "Crystal Palace",
      "note": ""
    },
    {
      "player": "Chadi Riad",
      "team": "Crystal Palace",
      "note": ""
    },
    {
      "player": "Eberechi Eze",
      "team": "Crystal Palace",
      "note": ""
    },
    {
      "player": "Marc Guéhi",
      "team": "Crystal Palace",
      "note": ""
    },
    {
      "player": "Maxence Lacroix",
      "team": "Crystal Palace",
      "note": ""
    },
    {
      "player": "Yannick Bolasie",
      "team": "Crystal Palace",
      "note": ""
    },
    {
      "player": "Iliman Ndiaye",
      "team": "Everton",
      "note": ""
    },
    {
      "player": "James Garner",
      "team": "Everton",
      "note": ""
    },
    {
      "player": "Jordan Pickford",
      "team": "Everton",
      "note": ""
    },
    {
      "player": "Phil Neville",
      "team": "Everton",
      "note": ""
    },
    {
      "player": "Yakubu",
      "team": "Everton",
      "note": ""
    },
    {
      "player": "Danny Murphy",
      "team": "Fulham",
      "note": ""
    },
    {
      "player": "Emile Smith Rowe",
      "team": "Fulham",
      "note": ""
    },
    {
      "player": "Jimmy Bullard",
      "team": "Fulham",
      "note": ""
    },
    {
      "player": "Josh King",
      "team": "Fulham",
      "note": "Rookie"
    },
    {
      "player": "Louis Saha",
      "team": "Fulham",
      "note": ""
    },
    {
      "player": "Illan Meslier",
      "team": "Leeds United",
      "note": ""
    },
    {
      "player": "Conor Bradley",
      "team": "Liverpool FC",
      "note": ""
    },
    {
      "player": "Cody Gakpo",
      "team": "Liverpool FC",
      "note": ""
    },
    {
      "player": "Diogo Jota",
      "team": "Liverpool FC",
      "note": ""
    },
    {
      "player": "Emile Heskey",
      "team": "Liverpool FC",
      "note": ""
    },
    {
      "player": "Harvey Elliott",
      "team": "Liverpool FC",
      "note": ""
    },
    {
      "player": "John Arne Riise",
      "team": "Liverpool FC",
      "note": ""
    },
    {
      "player": "Joe Gomez",
      "team": "Liverpool FC",
      "note": ""
    },
    {
      "player": "Ryan Gravenberch",
      "team": "Liverpool FC",
      "note": ""
    },
    {
      "player": "Rio Ngumoha",
      "team": "Liverpool FC",
      "note": "Rookie"
    },
    {
      "player": "Virgil van Dijk",
      "team": "Liverpool FC",
      "note": ""
    },
    {
      "player": "Bernardo Silva",
      "team": "Manchester City",
      "note": ""
    },
    {
      "player": "David Silva",
      "team": "Manchester City",
      "note": ""
    },
    {
      "player": "Emmanuel Adebayor",
      "team": "Manchester City",
      "note": ""
    },
    {
      "player": "Erling Haaland",
      "team": "Manchester City",
      "note": ""
    },
    {
      "player": "Joško Gvardiol",
      "team": "Manchester City",
      "note": ""
    },
    {
      "player": "Joe Hart",
      "team": "Manchester City",
      "note": ""
    },
    {
      "player": "John Stones",
      "team": "Manchester City",
      "note": ""
    },
    {
      "player": "Manuel Akanji",
      "team": "Manchester City",
      "note": ""
    },
    {
      "player": "Mateo Kovačić",
      "team": "Manchester City",
      "note": ""
    },
    {
      "player": "Matheus Nunes",
      "team": "Manchester City",
      "note": ""
    },
    {
      "player": "Micah Richards",
      "team": "Manchester City",
      "note": ""
    },
    {
      "player": "Oscar Bobb",
      "team": "Manchester City",
      "note": ""
    },
    {
      "player": "Phil Foden",
      "team": "Manchester City",
      "note": ""
    },
    {
      "player": "Rúben Dias",
      "team": "Manchester City",
      "note": ""
    },
    {
      "player": "Rico Lewis",
      "team": "Manchester City",
      "note": ""
    },
    {
      "player": "Riyad Mahrez",
      "team": "Manchester City",
      "note": ""
    },
    {
      "player": "Sávio",
      "team": "Manchester City",
      "note": ""
    },
    {
      "player": "Vitor Reis",
      "team": "Manchester City",
      "note": "Rookie"
    },
    {
      "player": "André Onana",
      "team": "Manchester United",
      "note": ""
    },
    {
      "player": "Bruno Fernandes",
      "team": "Manchester United",
      "note": ""
    },
    {
      "player": "Diogo Dalot",
      "team": "Manchester United",
      "note": ""
    },
    {
      "player": "Edwin van der Sar",
      "team": "Manchester United",
      "note": ""
    },
    {
      "player": "Gary Neville",
      "team": "Manchester United",
      "note": ""
    },
    {
      "player": "Harry Maguire",
      "team": "Manchester United",
      "note": ""
    },
    {
      "player": "Joshua Zirkzee",
      "team": "Manchester United",
      "note": ""
    },
    {
      "player": "Kobbie Mainoo",
      "team": "Manchester United",
      "note": ""
    },
    {
      "player": "Leny Yoro",
      "team": "Manchester United",
      "note": ""
    },
    {
      "player": "Mason Mount",
      "team": "Manchester United",
      "note": ""
    },
    {
      "player": "Manuel Ugarte",
      "team": "Manchester United",
      "note": ""
    },
    {
      "player": "Nemanja Vidić",
      "team": "Manchester United",
      "note": ""
    },
    {
      "player": "Patrice Evra",
      "team": "Manchester United",
      "note": ""
    },
    {
      "player": "Paul Scholes",
      "team": "Manchester United",
      "note": ""
    },
    {
      "player": "Shea Lacey",
      "team": "Manchester United",
      "note": "Rookie"
    },
    {
      "player": "Anthony Gordon",
      "team": "Newcastle United",
      "note": ""
    },
    {
      "player": "Bruno Guimarães",
      "team": "Newcastle United",
      "note": ""
    },
    {
      "player": "Harvey Barnes",
      "team": "Newcastle United",
      "note": ""
    },
    {
      "player": "Lewis Hall",
      "team": "Newcastle United",
      "note": ""
    },
    {
      "player": "Lewis Miley",
      "team": "Newcastle United",
      "note": ""
    },
    {
      "player": "Nick Pope",
      "team": "Newcastle United",
      "note": ""
    },
    {
      "player": "Sven Botman",
      "team": "Newcastle United",
      "note": ""
    },
    {
      "player": "Shay Given",
      "team": "Newcastle United",
      "note": ""
    },
    {
      "player": "Sandro Tonali",
      "team": "Newcastle United",
      "note": ""
    },
    {
      "player": "Tino Livramento",
      "team": "Newcastle United",
      "note": ""
    },
    {
      "player": "Anthony Elanga",
      "team": "Nottingham Forest",
      "note": ""
    },
    {
      "player": "Chris Wood",
      "team": "Nottingham Forest",
      "note": ""
    },
    {
      "player": "Matz Sels",
      "team": "Nottingham Forest",
      "note": ""
    },
    {
      "player": "Neco Williams",
      "team": "Nottingham Forest",
      "note": ""
    },
    {
      "player": "Zach Abbott",
      "team": "Nottingham Forest",
      "note": "Rookie"
    },
    {
      "player": "Archie Gray",
      "team": "Tottenham Hotspur",
      "note": ""
    },
    {
      "player": "Cristian Romero",
      "team": "Tottenham Hotspur",
      "note": ""
    },
    {
      "player": "Dejan Kulusevski",
      "team": "Tottenham Hotspur",
      "note": ""
    },
    {
      "player": "Dominic Solanke",
      "team": "Tottenham Hotspur",
      "note": ""
    },
    {
      "player": "Destiny Udogie",
      "team": "Tottenham Hotspur",
      "note": ""
    },
    {
      "player": "Gareth Bale",
      "team": "Tottenham Hotspur",
      "note": ""
    },
    {
      "player": "James Maddison",
      "team": "Tottenham Hotspur",
      "note": ""
    },
    {
      "player": "Lucas Bergvall",
      "team": "Tottenham Hotspur",
      "note": ""
    },
    {
      "player": "Ledley King",
      "team": "Tottenham Hotspur",
      "note": ""
    },
    {
      "player": "Mikey Moore",
      "team": "Tottenham Hotspur",
      "note": ""
    },
    {
      "player": "Son Heung-Min",
      "team": "Tottenham Hotspur",
      "note": ""
    },
    {
      "player": "Teddy Sheringham",
      "team": "Tottenham Hotspur",
      "note": ""
    },
    {
      "player": "Will Lankshear",
      "team": "Tottenham Hotspur",
      "note": "Rookie"
    },
    {
      "player": "Yang Min-hyeok",
      "team": "Tottenham Hotspur",
      "note": ""
    },
    {
      "player": "Aaron Wan-Bissaka",
      "team": "West Ham United",
      "note": ""
    },
    {
      "player": "Bobby Zamora",
      "team": "West Ham United",
      "note": ""
    },
    {
      "player": "Emerson Palmieri",
      "team": "West Ham United",
      "note": ""
    },
    {
      "player": "Jarrod Bowen",
      "team": "West Ham United",
      "note": ""
    },
    {
      "player": "Joe Cole",
      "team": "West Ham United",
      "note": ""
    },
    {
      "player": "Jean-Clair Todibo",
      "team": "West Ham United",
      "note": ""
    },
    {
      "player": "Luis Guilherme",
      "team": "West Ham United",
      "note": "Rookie"
    },
    {
      "player": "Lewis Orford",
      "team": "West Ham United",
      "note": "Rookie"
    },
    {
      "player": "Mohammed Kudus",
      "team": "West Ham United",
      "note": ""
    },
    {
      "player": "Maximilian Kilman",
      "team": "West Ham United",
      "note": ""
    },
    {
      "player": "Yossi Benayoun",
      "team": "West Ham United",
      "note": ""
    },
    {
      "player": "Jørgen Strand Larsen",
      "team": "Wolverhampton Wanderers",
      "note": ""
    },
    {
      "player": "Matheus Cunha",
      "team": "Wolverhampton Wanderers",
      "note": ""
    },
    {
      "player": "Tommy Doyle",
      "team": "Wolverhampton Wanderers",
      "note": ""
    }
  ],
  "beastModeAuto": [
    {
      "player": "Evanilson",
      "team": "AFC Bournemouth",
      "note": ""
    },
    {
      "player": "Declan Rice",
      "team": "Arsenal",
      "note": ""
    },
    {
      "player": "Georginio Rutter",
      "team": "Brighton & Hove Albion",
      "note": ""
    },
    {
      "player": "Hannibal",
      "team": "Burnley FC",
      "note": ""
    },
    {
      "player": "Enzo Fernández",
      "team": "Chelsea",
      "note": ""
    },
    {
      "player": "John Terry",
      "team": "Chelsea",
      "note": ""
    },
    {
      "player": "Beto",
      "team": "Everton",
      "note": ""
    },
    {
      "player": "Daniel James",
      "team": "Leeds United",
      "note": ""
    },
    {
      "player": "Virgil van Dijk",
      "team": "Liverpool FC",
      "note": ""
    },
    {
      "player": "Rodri",
      "team": "Manchester City",
      "note": ""
    },
    {
      "player": "Alejandro Garnacho",
      "team": "Manchester United",
      "note": ""
    },
    {
      "player": "Sandro Tonali",
      "team": "Newcastle United",
      "note": ""
    },
    {
      "player": "Chris Wood",
      "team": "Nottingham Forest",
      "note": ""
    },
    {
      "player": "Dominic Solanke",
      "team": "Tottenham Hotspur",
      "note": ""
    },
    {
      "player": "Ledley King",
      "team": "Tottenham Hotspur",
      "note": ""
    },
    {
      "player": "Emerson Palmieri",
      "team": "West Ham United",
      "note": ""
    }
  ],
  "chromeKingsAuto": [
    {
      "player": "Cesc Fàbregas",
      "team": "Arsenal",
      "note": ""
    },
    {
      "player": "Dwight Yorke",
      "team": "Aston Villa",
      "note": ""
    },
    {
      "player": "Didier Drogba",
      "team": "Chelsea",
      "note": ""
    },
    {
      "player": "Gianfranco Zola",
      "team": "Chelsea",
      "note": ""
    },
    {
      "player": "Julián Speroni",
      "team": "Crystal Palace",
      "note": ""
    },
    {
      "player": "Nathaniel Clyne",
      "team": "Crystal Palace",
      "note": ""
    },
    {
      "player": "Leighton Baines",
      "team": "Everton",
      "note": ""
    },
    {
      "player": "Danny Murphy",
      "team": "Fulham",
      "note": ""
    },
    {
      "player": "Jimmy Floyd Hasselbaink",
      "team": "Leeds United",
      "note": ""
    },
    {
      "player": "Steven Gerrard",
      "team": "Liverpool FC",
      "note": ""
    },
    {
      "player": "Xabi Alonso",
      "team": "Liverpool FC",
      "note": ""
    },
    {
      "player": "David Silva",
      "team": "Manchester City",
      "note": ""
    },
    {
      "player": "Sergio Agüero",
      "team": "Manchester City",
      "note": ""
    },
    {
      "player": "Nemanja Vidić",
      "team": "Manchester United",
      "note": ""
    },
    {
      "player": "Wayne Rooney",
      "team": "Manchester United",
      "note": ""
    },
    {
      "player": "Andy Cole",
      "team": "Newcastle United",
      "note": ""
    },
    {
      "player": "Roy Keane",
      "team": "Nottingham Forest",
      "note": ""
    },
    {
      "player": "Gareth Bale",
      "team": "Tottenham Hotspur",
      "note": ""
    },
    {
      "player": "Bobby Zamora",
      "team": "West Ham United",
      "note": ""
    },
    {
      "player": "Paul Ince",
      "team": "Wolverhampton Wanderers",
      "note": ""
    }
  ],
  "blackEdgeAutos": [
    {
      "player": "Cole Palmer",
      "team": "Chelsea",
      "note": ""
    },
    {
      "player": "Eberechi Eze",
      "team": "Crystal Palace",
      "note": ""
    },
    {
      "player": "Clint Dempsey",
      "team": "Fulham",
      "note": ""
    },
    {
      "player": "Fernando Torres",
      "team": "Liverpool FC",
      "note": ""
    },
    {
      "player": "Rio Ngumoha",
      "team": "Liverpool FC",
      "note": "Rookie"
    },
    {
      "player": "Erling Haaland",
      "team": "Manchester City",
      "note": ""
    },
    {
      "player": "Alan Shearer",
      "team": "Newcastle United",
      "note": ""
    },
    {
      "player": "Chris Wood",
      "team": "Nottingham Forest",
      "note": ""
    },
    {
      "player": "Son Heung-Min",
      "team": "Tottenham Hotspur",
      "note": ""
    },
    {
      "player": "Matheus Cunha",
      "team": "Wolverhampton Wanderers",
      "note": ""
    }
  ]
};